window.handle = require("handlebars/dist/handlebars.js");

handle.registerHelper('stripHtml', function(label){

    label = handle.escapeExpression(label);
    if(label.indexOf("-->", 3) != -1){

        var comment_position = parseInt(label.indexOf("-->", 3));
        return new handle.SafeString(label.substr(comment_position + 3));

    } else {

        return new handle.SafeString(label)

    }

});

handle.registerHelper('check', function(value, comparator) {
    if(value !== comparator){ return `<li>${value}</li>` ;} // filters out empty list values when description is returned as html not a string 
});

handle.registerHelper('renderArrow', function(index) {
    if(index == 1){ return `<img class="img-responsive full-width" src="img/tcpa_arrow.png">`}; // renders a big arrow that points to the first option
});

handle.registerHelper('recommended', function(index) {
    if(index == 1){ return `<div id="recommended">&#10004; Recommended</div>`} else {return `<div class="number">${index}</div>`}; // renders a big arrow that points to the first option
});

let isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

let currentDriver = 1;

(function($){


    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="session-token"]').attr('content')
        }
    });

    $(window).keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });

    $("#zip").on("change", function(){
        let zipCode = $(this).val();
        zipValidator(zipCode);
    })

    $("#phone").on("change", function(){
        let phoneNumber = $(this).val();
        phoneValidator(phoneNumber);
    })

    $("#email").on("change", function(){
        let email = $(this).val();
        emailValidator(email);
    })

    $("#email").on("keyup input", function(){
        let emails = ["@gmail.com", "@yahoo.com", "@aol.com", "@hotmail.com"];

        let idx = $(this).val().indexOf("@");
        
        if(idx == -1){
            $("#emailOptions").focus();
            emails.forEach(email => {
                $("#emailOptions").append(
                    `<option class="emailAutofill" value='${$("#email").val()}${email}' >${$("#email").val()}${email}</option>`    
                )
            })
        }
    })

    $("#driver2-month, #driver3-month, #driver4-month, #month").on("keyup input", function(){
        
        let _this = $(this);

        let value = _this.val().split('');

        if(parseInt(value[0]) > 1){
            $(this).val(`0${value[0]}`);
            _this.next("input").focus();
        } else if(parseInt(value[0]) === 1 && parseInt(value[1]) > 2){
            $(this).val("");
            return false;
        }

        setTimeout(function() {
            if ( _this.val().length >= parseInt(_this.attr("maxlength"),10) )
                _this.next("input").focus();
            },0)

    })

    $("#driver2-day, #driver3-day, #driver4-day, #day").on("keyup input", function(){

        let _this = $(this);
        
        let value = _this.val().split('');

        if(parseInt(value[0]) > 3){
            $(this).val(`0${value[0]}`);
            _this.next("input").focus();
        } else if(parseInt(value[0] <= 3) && parseInt(value[1] <= 1)){
            $(this).val(value.join(""));
            _this.next("input").focus();
        } else if(parseInt($(this).val()) > 32) {
            $("#day").val("");
            return false;
        }

        setTimeout(function() {
            if ( _this.val().length >= parseInt(_this.attr("maxlength"),10) )
                _this.next("input").focus();
            },0)
    })

    $("#driver2-dobYear, #driver3-dobYear, #driver4-dobYear, #dobYear").on("keyup input", function(){
                 
        let _this = $(this);

        let year = parseInt(_this.val());
      
        let length = _this.val().length;

        if(length === 4 && (year < 1900 || year > 2004)){
            $(this).val("");
            return false;
        } else if(length === 4 && (year > 1900 || year < 2004 )) {
            if(currentDriver == 1){
                $("#dob-button").trigger("click");
            } else {
                $(`#dob-button${currentDriver}`).trigger("click");
            }
        }

    });

    $("#dob-button").on("click", function(){

        if($("#day").val() == "") return false;
        if($("#month").val() == "") return false;

        if($("#day").val().length !== 2){
            $(".errorMsgDOB").html("Please enter a valid, two digit day.");
            return false;
        } else if($("#month").val().length !== 2){
            $(".errorMsgDOB").html("Please enter a valid, two digit month.");
            return false;
        } else if($("#dobYear").val().length !== 4){
            $(".errorMsgDOB").html("Please enter a valid year.");
            return false;
        } else{
            $(".errorMsgDOB").html("");
        }
    })

    $("#dob-button2").on("click", function(){

        if($("#driver2-day").val() == "") return false;
        if($("#driver2-month").val() == "") return false;

        if($("#driver2-day").val().length !== 2){
            $(".errorMsgDOB").html("Please enter a valid, two digit day.");
            return false;
        } else if($("#driver2-month").val().length !== 2){
            $(".errorMsgDOB").html("Please enter a valid, two digit month.");
            return false;
        } else if($("#driver2-dobYear").val().length !== 4){
            $(".errorMsgDOB").html("Please enter a valid year.");
            return false;
        } else{
            $(".errorMsgDOB").html("");
        }
    })

    $("#dob-button3").on("click", function(){

        if($("#driver3-day").val() == "") return false;
        if($("#driver3-month").val() == "") return false;

        if($("#driver3-day").val().length !== 2){
            $(".errorMsgDOB").html("Please enter a valid, two digit day.");
            return false;
        } else if($("#driver3-month").val().length !== 2){
            $(".errorMsgDOB").html("Please enter a valid, two digit month.");
            return false;
        } else if($("#driver3-dobYear").val().length !== 4){
            $(".errorMsgDOB").html("Please enter a valid year.");
            return false;
        } else{
            $(".errorMsgDOB").html("");
        }
    })

    $("#dob-button4").on("click", function(){

        if($("#driver4-day").val() == "") return false;
        if($("#driver4-month").val() == "") return false;

        if($("#driver4-day").val().length !== 2){
            $(".errorMsgDOB").html("Please enter a valid, two digit day.");
            return false;
        } else if($("#driver4-month").val().length !== 2){
            $(".errorMsgDOB").html("Please enter a valid, two digit month.");
            return false;
        } else if($("#driver4-dobYear").val().length !== 4){
            $(".errorMsgDOB").html("Please enter a valid year.");
            return false;
        } else{
            $(".errorMsgDOB").html("");
        }
    })

    //filter out special characters
    $("#firstName, #driver2-firstName, #driver3-firstName, #driver4-firstnName, #lastName, #driver2-lastName, #driver3-lastName, #driver4-lastName").on("keyup input", function(){
        let validator =/[0-9*|\":<>[\]{}`\\();@&$!#%^_+=?./]/;
        let txt = $(this).val();
        if (validator.test(txt)){
            $(this).val(txt.replace(/[^a-zA-Z ]/g, ''));
        }
    })

    $(".dateslider").on("change", function(){
        let newMonth = $(".dateslider").val();
        let month;
        if(newMonth == 1) {
            month = " month"
        } else if(newMonth == 36){
            month = "+ months";
        } else {
            month = " months";
        }
        $(".range-output").html(newMonth + month);
    })

    $("input[name='residenceStatus']").on("click", function(){
        setTimeout(function(){
            $("#month").focus();
        }, 500)
    })

    $("input[name='driver2-militaryStatus']").on("click", function(){
        setTimeout(function(){
            $("#driver2-month").focus();
        }, 500)
    })

    $("input[name='driver3-militaryStatus']").on("click", function(){
        setTimeout(function(){
            $("#driver3-month").focus();
        }, 500)
    })

    $("input[name='driver4-militaryStatus']").on("click", function(){
        setTimeout(function(){
            $("#driver4-month").focus();
        }, 500)
    })

    $("#zip").on("change", function(){
        let zipCode = $(this).val();
        zipValidator(zipCode);
    })

    $("#phone").on("change", function(){
        let phoneNumber = $(this).val();
        phoneValidator(phoneNumber);
    })

    $("#email").on("change", function(){
        let email = $(this).val();
        emailValidator(email);
    })

    $(".clickSubmit").on("click", function(){
        if($('#firstName').val() == "" || $('#lastName').val() == ""){
            $("#blank-error").fadeIn(300), setTimeout((function () {$("#blank-error").fadeOut(300);}), 5e3)
        }
    })

    $("#firstName, #lastName, #driver2-firstName, #driver2-lastName, #driver3-firstName, #driver3-lastName, #driver4-firstName, #driver4-lastName").on("change", function(){
        if($(this).val() !== ""){
            $(".errorMsg").html("")
        }
    })

    $("#driver1-info, #driver2-info, #driver3-info, #driver4-info").on("click", function(){
        
        if(currentDriver == 1){ 
            if($('#firstName').val() == "" || $('#lastName').val() == ""){
                $(".errorMsg").html("Please Fill Out All Fields")
                return false;
            } else {
                $(".errorMsg").html("")
                currentDriver ++;
            }
        } else {
            if($(`#driver${currentDriver}-firstName`).val() == "" || $(`#driver${currentDriver}-lastName`).val() == "" || $(`#driver${currentDriver}-relationship`).val() == undefined){
                $(".errorMsg").html("Please Fill Out All Fields")
                return false;
            } else {
                $(".errorMsg").html("")
                currentDriver ++;
            }
        }
    })

    let zipValidator = (zipCode) => {
        
        zipCode.length >= 3 && zipCode.length <= 5 ? ajaxGet("assets/ajax/zipValidator.php?zip=" + zipCode).then((function (t) {
            if ("success" === t.data.status) {
                var e = t.data;
                localStorage.setItem('zip', zipCode);
                localStorage.setItem('city',e.data.city);
                $(".getCity, .getState").empty(),  $(".getCity").html(e.data.city + ","), $(".getState").html(e.data.state), $("input[name='city']").val(e.data.city), $("input[name='state']").val(e.data.state), $("#zipError").removeClass('invalid'),$("#zipError").html("");
            } else if ("error" === t.data.status) {
                var r = t.data.error_msg;
                $(".getCity, .getState").empty();
                var s = "<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n".concat(r, "\n</span>");
                $("#zipError").html(s), $("#zipError").addClass('invalid');
            }
        })) : ($(".getCity, .getState").empty(), $("#zipError").html("<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n <i class='fa fa-exclamation-triangle'></i>\n Please check your USA zip code again.\n </span>"), $("#zipError").addClass('invalid'));
    }

    let phoneValidator = (phoneNumber) => {
        phoneNumber.length >= 10 && phoneNumber.length <= 14 ? ajaxGet("assets/ajax/phoneValidator.php?phone=" + phoneNumber)
            .then(function(t){
                if ("error" === t.data.status) {
                    let r = "<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n <i class='fa fa-exclamation-triangle'></i>\n".concat(t.data.error_message, "\n</span>");
                    $("#phoneError").empty().html(r);
                } else {
                    $("#phoneError").html("");
                    $("#phoneError").removeClass('invalid');
                    let e = t.data;
                    $('#phone').val(phoneNumber.replace(/\D/g, ''));
                }
            }) : $("#phoneError").html("<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n Please enter a valid US Phone Number.\n</span>");
        $("#phoneError").addClass('invalid');
    }

    let emailValidator = (email) => {
        email.length >= 6 && email.length <= 256 ? ajaxGet("assets/ajax/emailValidator.php?email=" + email).then((function (resp) {
            if ("success" === resp.data.status) {
                $("#emailError").html(""), $("#emailError").removeClass('invalid');
            } else if ("failure" === resp.data.status) {
                var r = "<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n".concat(resp.data.error_message, "\n </span>");
                $("#emailError").empty().html(r)
            }
        })) :  $("#emailError").html("<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n <i class='fa fa-exclamation-triangle'></i>\nPlease check your Email address again.\n</span>"), $("#emailError").addClass('invalid');
    }

    let ajaxGet = (url) => {
        return new Promise(function(resolve, reject){
            $.ajax({
                type:"GET",
                url: url,
            }).done(function(data, status){
                resolve({data, status});
            }).fail(function(data, status){
                reject({data,status});
            });
        });
    };

    
})(jQuery);